module.exports = __webpack_public_path__ + "assets/OuterTangentDetailed.0ed6fad0eeedc4fa83ebde0fecbbe1af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/OuterTangentDetailed.png
// module id = 543
// module chunks = 0